module.exports = __webpack_public_path__ + "static/img/no-pic.4a682595.svg";